// Modules
import { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'

// Hooks
import useNotices from 'hooks/system/useNotices'

// Constants
import { PASSWORD_RESET_URL } from 'constants/environment'

// Hook: Authentication > Password reset
function usePasswordReset (payload) {
	// State
	const [error, setError] = useState(null)
	const [isProcessing, setIsProcessing] = useState(false)

	// Data
	const navigate = useNavigate()
	const { addNotice } = useNotices()

	// Functions (Memoized)
	const reset = useCallback (async payload => {
		setIsProcessing(true)
		try {
			const response = await axios({
				data: { code: payload.code, email: payload.email, password: payload.password },
				method: 'POST',
				url: PASSWORD_RESET_URL
			})
			if (response?.status < 300) {
				navigate('/')
				window.dataLayer.push({ event: 'account-password-reset' })
			}
		} catch (error) {
			setError(error)
		}
		setIsProcessing(false)
	}, [navigate])

	// Effects
	useEffect(() => {
		if (!!error) addNotice({ code: `server.${error?.response?.data?.message}`, log: error, type: 'error' })
	}, [addNotice, error])

	// Response
	return { error, isProcessing, reset }
}

// Export
export default usePasswordReset
